import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import cate from '../views/cate.vue'
//抽奖
import lottery from '../views/lottery.vue'
import myPrize from '../views/myPrize.vue'
import lucky from '../views/lucky.vue'

//学习
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: 'index',
    component: index,
    meta: {
      title: '潮玩河北！景点门票免费送'
    }
  }, 
  {
    path: '/cate',
    name: 'cate',
    component: cate,
    meta: {
      title: '选择盲盒'
    }
  },  
  {
    path: '/lottery',
    name: 'lottery',
    component: lottery,
    meta: {
      title: '开盲盒'
    }
  },
  {
    path: '/myPrize',
    name: 'myPrize',
    component: myPrize,
    meta: {
      title: '查奖品'
    }
  },
  {
    path: '/lucky',
    name: 'lucky',
    component: lucky,
    meta: {
      title: '中奖名单'
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: '/webpage/lottery_blind_wenlv/', //配置二级目录  
  routes
})

//解决重复点击相同路由报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//全局前置守卫
router.beforeEach((to, from, next) => {

  if (to.meta.title) {
    document.title = to.meta.title
  }
  let accountId = store.state.accountId;
  let uniqueId = store.state.uniqueId;

  if (to.path !== "/index") {
    if (!accountId || !uniqueId) {
      next({ path: '/index?app_control=1101', query: to.query });
    } else {
      //全局添加参数app_control=1101
      if (to.query.app_control === undefined) {
        const app_control = { ...to.query, app_control: '1101' };
        next({ ...to, query: app_control });
      } else {
        next();
      }

    }
  } else {
    //全局添加参数app_control=1101
    if (to.query.app_control === undefined) {
      const app_control = { ...to.query, app_control: '1101' };
      next({ ...to, query: app_control });
    } else {
      next();
    }
  }

})

export default router
